import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserNotes, UserNotesWrapper } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WindowService } from '../dom/window.service';

@Injectable({
  providedIn: 'root',
})
export class UserNotesService {
  constructor(
    private http: HttpClient,
    public sanitizer: DomSanitizer,
    private windowService: WindowService,
  ) {}

  private sanitizeFn = (item) => {
    item.note = this.sanitizer.bypassSecurityTrustHtml(item.note as string);
    return item;
  };

  public loadUserNotes(target: string): Observable<UserNotesWrapper> {
    if ((this.windowService.getWindow() as any).isServerSide) {
      return of(undefined);
    }

    return this.http.get<UserNotesWrapper>(`${environment.apihost + environment.usernotes}/${target}`).pipe(
      map((result: UserNotesWrapper) => {
        const sanitized = new UserNotesWrapper();
        if (!result) {
          return sanitized;
        }

        if (result.danger) {
          sanitized.danger = result.danger.map(this.sanitizeFn);
        }
        if (result.info) {
          sanitized.info = result.info.map(this.sanitizeFn);
        }
        if (result.success) {
          sanitized.success = result.success.map(this.sanitizeFn);
        }
        if (result.custom) {
          sanitized.custom = result.custom.map(this.sanitizeFn);
        }

        return sanitized;
      }),
      catchError(() => of({})),
    );
  }

  public loadNotes(type: 'ads' | 'aktuelles' | 'memberhomedate'): Observable<UserNotes[]> {
    if ((this.windowService.getWindow() as any).isServerSide) {
      return of(undefined);
    }

    return this.http.get<UserNotesWrapper>(`${environment.apihost + environment.usernotes}/${type}`).pipe(
      catchError(() => of(undefined)),
      map((result: UserNotesWrapper) => {
        if (!result) {
          return [];
        }

        const notes: UserNotes[] = [];
        if (result.danger) {
          notes.push(...result.danger.map(this.sanitizeFn));
        }
        if (result.info) {
          notes.push(...result.info.map(this.sanitizeFn));
        }
        if (result.success) {
          notes.push(...result.success.map(this.sanitizeFn));
        }
        if (result.custom) {
          notes.push(...result.custom.map(this.sanitizeFn));
        }
        return notes;
      }),
    );
  }

  public dismissNotes(notes: UserNotes[]): void {
    this.http
      .post(
        environment.apihost + environment.usernotesdismiss,
        notes.map((note) => note.id),
      )
      .subscribe(() => {
        // do nothing
      });
  }
}
